import api from '../../../services/Api';
import { IAuditoriaContasPagarReceberResultado } from '../interfaces/IAuditoriaContasPagarReceber';

export const AuditoriaContasPagarReceberService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaContasPagarReceberResultado> {
    const response = await api.get<IAuditoriaContasPagarReceberResultado>('auditoria-contas-pagar-receber/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoNaturezaInvertida: '',
        contasComNaturezaInvertida: [],
        contasConciliadas: [],
      }
    );
  },
};
